/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

'use client';
import React from 'react';
// Subpath: the nps barrel would pull the NPS/CSAT pages in too.
import { FeedbackProvider } from '@airasia-rn/nps/feedback';
import type { FeedbackProps } from '@airasia-rn/nps/types';
import { MoveWebPageProps } from './types';
import { MoveWebPageClient } from './MoveWebPageClient';

const MoveWebPage: React.FC<MoveWebPageProps> = (props) => {
  const { currencyList, localeList } = props;

  return (
    <FeedbackProvider enableGuestFeedback={true}>
      <MoveWebPageClient
        {...props}
        currencyList={currencyList}
        localeList={localeList}
      />
    </FeedbackProvider>
  );
};

export default MoveWebPage;
